'use strict';

var SimpleHepGridDirective = function SimpleHepGridDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/simple-hep-grid.html'),
    controller: 'SimpleHepGridController'
  };
};
SimpleHepGridDirective.$inject = [];
module.exports = SimpleHepGridDirective;